export default "__VITE_ASSET__BJgOYq2R__"